module.exports = __webpack_public_path__ + "img/782114.f1797581.jpg";